<template>

    <div class="applyform">
        <div class="body">
            <div class="body-content">
                <div class="fontSize4 body-main">
                    <div class="body-title">
                        申请试用
                    </div>
                    <div class="close">
                        <span @click="setApplyformShow(false)" class="iconfont icon-guanbi1"></span>
                    </div>
                    <div class="row">
                        <label for="name">姓名</label>
                        <input class="fontSize4 row_input" type="text" id="name" v-model="truename"/>
                    </div>
                    <div class="row">
                        <label for="phone">手机号</label>
                        <input class="fontSize4" type="text" id="phone" v-model="tel"/>
                    </div>
                    <div class="row">
                        <label for="email">企业邮箱</label>
                        <input class="fontSize4" type="text" id="email" v-model="email"/>
                    </div>
                    <div class="row" v-clickoutside="companyListHide">
                        <label for="company">公司全称</label>
                        <input class="fontSize4" type="text" id="company" v-model="company" @input="companyOnInput"/>
                        <ul class="company-list" v-show="companyListShow">
                            <li @click="companyLiClick(item)" v-for="(item, index) in companyList" :key="index">
                                {{item}}
                            </li>
                        </ul>
                    </div>
                    <div v-show="false" class="row">
                        <label for="address">收货地址</label>
                        <input class="fontSize4" type="text" id="address" v-model="address"/>
                    </div>
                    <div class="row">
                        <label class="textarea-label" style="" for="reason">申请理由（5-150字）</label>
                        <textarea class="fontSize4" v-model="reason" name="" id="reason" cols="30" rows="10">
						</textarea>
                    </div>
                    <div class="row yinsi-div">
                        <input class="checkbox" type="checkbox" id="tongyi" v-model="tongyi"/>
                        <label for="tongyi" class="yinsi-text">
                          <span class="text-check"></span>
                          我同意Dell Technologies 及其公司集团（简称“戴尔”）与我保持联系。戴尔将及时通过电子邮件或电话/短信向您通报有关产品、服务、解决方案、专属优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请阅读戴尔的
                          <a target="_blank" href="https://www.dell.com/learn/cn/zh/cncorp1/policies-privacy" class="text-blue">隐私声明</a>。您可以随时取消订阅。
                        </label>
                        <!--
                        <a style="flex-grow: 20;color:#4c9ca1;"  @click.prevent="showApplyAlert = true"   href="#戴尔会员协议">
                          戴尔会员协议
                        </a>
                        -->
                    </div>
                    <div class="row">
                        <button :class="{disabled : !tongyi}" @click="submit" class="fontSize2 btn">申请试用 ></button>
                    </div>
                </div>
            </div>
        </div>
        <div @touchmove.prevent v-show="showApplyConfirm" class="apply-mask"></div>
        <div @touchmove.prevent v-show="showApplyConfirm" class="applyConfirm">
            <div class="content">
                <div class="title">申请成功！</div>
                <div class="coupon-infor" v-if="hasCoupon">恭喜您获得{{couponTitle}}</div>
                <div class="text">邀请好友点赞，赞数越高，申请成功的概率越大</div>
                <img class="coupon-img" v-if="hasCoupon" :src="couponImg" alt="">
                <img class="success-img" v-if="!hasCoupon" src="~@/assets/detail/apply-success.png" alt="">
                <div class="btnGroup">
                    <template v-if="!hasCoupon">
                        <button @click="cancel" class="btn-line">关　闭 ></button>
                        <button @click="go">邀请点赞 ></button>
                    </template>
                    <template v-else>
                        <button @click="go" class="btn-line">邀请点赞 ></button>
                        <button @click="clickCoupon">立即使用 ></button>
                    </template>
                </div>
            </div>
            <div class="close-icon" @click="cancel">
                <span class="iconfont icon-guanbi1"></span>
            </div>
        </div>

        <div v-show="showApplyAlert" class="applyAlert">
            <div class="body2">
                <div v-html="site_yhxy"></div>
                <img @click="showApplyAlert = false" class="close" src="@/assets/close3.png"/>
            </div>
        </div>
    </div>

</template>
<script>
    import {mapState} from 'vuex'

    export default {
        name: 'applyform',
        data() {
            return {
                showApplyConfirm: false,
                truename: '',
                tel: '',
                email: '',
                company: '',
                address: '',
                reason: '',
                submitIng: false,
                tongyi: '',
                showApplyAlert: false,
                companyListShow: false,
                companyList: [],
                companySearch: false,
                companySetTime: undefined,
                ifMatchingcompanyName: false,
            }
        },
        directives: {
            clickoutside: {
                bind: function (el, binding, vnode) {
                    function documentHandler(e) {
                        // 这里判断点击的元素是否是本身，是本身，则返回
                        if (el.contains(e.target)) {
                            return false;
                        }
                        // 判断指令中是否绑定了函数
                        if (binding.expression) {
                            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                            binding.value(e);
                        }
                    }

                    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
                    el.__vueClickOutside__ = documentHandler;
                    document.addEventListener('click', documentHandler);
                },
                update: function () {
                },
                unbind: function (el, binding) {
                    document.removeEventListener('click', el.__vueClickOutside__);
                    delete el.__vueClickOutside__;
                }
            }
        },
        computed: mapState([
            'site_yhxy',
            'hasCoupon',
            'couponTitle',
            'couponImg',
            'couponUrl',
        ]),
        watch: {
            company(newText, oldText) {
                if (!this.isTwoChinese(newText) || !this.companySearch) return;
                if (this.companySetTime) clearTimeout(this.companySetTime);
                this.companySetTime = setTimeout(() => {
                    this.axios.post('https://www.dellemc-solution.com/api/search/company', {
                        keyword: newText
                    }).then(({data}) => {
                        if (data.errCode === 0) {
                            this.companyList = data.data;
                            this.companyListShow = this.companyList.length > 0;
                            gioTrackAction('QCCcompany_impressions');  //埋点实施方案
                        }
                    });
                }, 600);

            }
        },
        methods: {
            companyLiClick(text) {
                this.company = text;
                this.ifMatchingcompanyName = true;
                this.companySearch = false;
                this.companyListHide();
                gioTrackAction('QCCcompany_click');  //埋点实施方案
            },
            companyListHide() {
                this.companyListShow = false;
            },
            isTwoChinese(val) {
                return !!val.match(/[^\x00-\xff]/ig) && val.match(/[^\x00-\xff]/ig).length >= 2;
            },
            companyOnInput() {
                this.companySearch = true;
                this.ifMatchingcompanyName = false;
            },
            getSmarketLoginInfo: function () {
                let smarketCookie = this.cookies.get('smarketMember_498');
                if (smarketCookie) {
                    smarketCookie = JSON.parse(smarketCookie);
                    this.axios.post('https://api.dellemc-solution.com/member/LookUp', {
                        sess: smarketCookie.session
                    }).then(res => {
                        console.log(res);
                        if (res.data.body.result == 0 && res.data.body.content.length > 0) {
                            res.data.body.content.forEach(obj => {
                                if (obj.key == "name") {
                                    this.truename = obj.value;
                                } else if (obj.key == "mobile") {
                                    this.tel = obj.value;
                                } else if (obj.key == "email") {
                                    this.email = obj.value;
                                } else if (obj.key == "enterprise_name") {
                                    this.company = obj.value;
                                } else if (obj.key == "province" && typeof obj.value == "object") {
                                    this.address = obj.value.join(',');
                                }
                            })
                        }
                    })
                }

            },
            //检查EMAIL
            isEmail: function (str) {
                var reg = /^\S+@\S+$/;
                var flag = reg.test(str);
                return flag;
            },
            submit() {

                if (!this.tongyi) return;

                if (this.truename == '') {
                    alert('没有填写姓名');
                    return;
                }

                if (this.tel == '') {
                    alert('没有填写手机号');
                    return;
                }

                if (this.tel.length != 11) {
                    alert('请填写正确的手机号');
                    return;
                }

                if (this.email == '') {
                    alert('没有填写企业邮箱');
                    return;
                }

                if (!this.isEmail(this.email)) {
                    alert('请填写正确的企业邮箱');
                    return;
                }

                if (this.company == '') {
                    alert('没有填写公司全称');
                    return;
                }

                /*
                if(this.address == ''){
                  alert('没有填写收货地址');
                  return;
                }
                */
                this.address = '暂无';

                if (this.reason == '') {
                    alert('没有填写申请理由');
                    return;
                } else {
                    if (this.reason.length < 5 || this.reason.length > 150) {
                        alert('申请理由5-150个字');
                        return;
                    }
                }


                //console.log([this.name,this.shr,this.phone,this.dizhi,this.email,this.sqly,this.tongyi])
                if (this.submitIng === true) return;
                this.submitIng = true;

                try {
                    var _this = this;
                    gioTrackAction('campaign0yuan_Submit', {
                        phoneNumber: common.mobileEncryption(_this.tel),
                        ifMatchingcompanyName: _this.ifMatchingcompanyName,
                    });
                    gioTrackAction('QCCcompany_formsubmitsuccess', {
                        phoneNumber: common.mobileEncryption(_this.tel),
                        ifMatchingcompanyName: _this.ifMatchingcompanyName,
                    });
                } catch (e) {
                    console.log(e);
                }
                let smarketCookie = this.cookies.get("smarketMember_498");
                let memberInfo = {};
                try {
                    memberInfo = JSON.parse(smarketCookie);
                } catch (error) {

                }
                this.axios.post('/campaigns-b/try/index.php?_c=detail&_a=apply&tid=' + this.$store.state.tid, {

                    truename: this.truename,
                    tel: this.tel,
                    email: this.email,
                    company: this.company,
                    address: this.address,
                    reason: this.reason,
                    sess: memberInfo.session,
                    source: 'wap',

                    // utm参数
                    utm_campaign: this.utm.utm_campaign,
                    utm_content: this.utm.utm_content,
                    utm_term: this.utm.utm_term,
                    utm_medium: this.utm.utm_medium,
                    utm_source: this.utm.utm_source
                })
                    .then((response) => {

                        var d = response.data.data;
                        this.submitIng = false;
                        if (response.data.code == 500) {
                            alert(response.data.msg)
                            return;
                        }
                        //console.log(response)
                        this.aid = d.aid;

                        this.showApplyConfirm = true;
                    })
                    .catch((error) => { // 请求失败处理
                        this.submitIng = false;
                        this.showApplyConfirm = true;
                        console.log(error);
                    });


                //this.$store.commit('setApplyformShow',false);
            },
            cancel() {

                this.showApplyConfirm = false;
                this.$store.commit('setApplyformShow', false);
                this.$router.push({
                    path: '/show/' + this.aid
                }).catch(err => {
                    err
                })
            },
            go() {
                console.log('go', this.$store.state.miniapp);
                if (this.$store.state.miniapp) {
                    wx.miniProgram.redirectTo({url: `/pages/try/show?aid=${this.aid}`});
                    return;
                } else {
                    this.showApplyConfirm = false;
                    this.$store.commit('setApplyformShow', false);
                    this.$router.push({
                        path: '/show/' + this.aid
                    }).catch(err => {
                        err
                    });
                    setTimeout(() => {
                        this.$store.commit('setState', {
                            showShare: true
                        });
                    }, 1000)
                }

            },
            setApplyformShow(val) {
                this.$store.commit('setApplyformShow', val);
            },
            clickCoupon() {
                if (this.hasCoupon) {
                    window.open(this.couponUrl);
                }
            },
        },

        props: ['tid'],
        beforeDestroy() {
            console.log('applyeform beforeDestroy')
        },
        created() {
            console.log('applyform   created')
            this.getSmarketLoginInfo();
        }
    }
</script>
<style scoped lang="scss">
    .btn {
        outline: none;
        border: none;
        display: block;
        margin: .15rem auto .15rem;
        width: 2.2rem;
        height: .56rem;
        line-height: .56rem;
        text-align: center;
        font-size: .3rem;
        color: #fff;
        background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);

        &:active {
            opacity: .9;
        }

        &.disabled {
            background-image: linear-gradient(-90deg, rgb(133, 133, 133) 1%, rgb(106, 106, 106) 100%);
        }
    }

    .btn.disabled {
        background: #ababab;
    }


    .applyform {
        /*background: #315182;*/
        background-image: url("~@/assets/detail/detail-bg.jpg");
        background-repeat: repeat-y;
        /*background-repeat: no-repeat;*/
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 102;
        padding: 4.5vw 4.3vw;

        .body {
            width: 100%;
            background: #fff;
            border-radius: .13rem;
        }

        .body-content {
            width: 100%;
            max-height: 96vh;
            overflow-y: auto;
        }

        .body-main {
            position: relative;
            width: 100%;
            padding: .6rem .35rem;

            .close {
                position: absolute;
                top: .2rem;
                right: .2rem;

                .iconfont {
                    font-size: .4rem;
                    color: #9c9c9c;
                }
            }
        }

        .body-title {
            text-align: center;
            font-size: .35rem;
            font-weight: bold;
            color: #000;
            margin-bottom: .6rem;
        }

        .row {
            display: flex;
            flex-direction: column;
            margin-bottom: 3.3vw;
            position: relative;

            input[type=text] {
                outline: #5b6f84;
                padding-left: 1.8rem;
                width: 100%;
                height: .74rem;
                border: 1px solid #5b6f84;
                border-radius: .05rem;

                &[type=text]::-webkit-input-placeholder {
                    color: #000;
                    font-weight: bold;
                }
            }

            textarea::-webkit-input-placeholder {
                color: #000;
                font-weight: bold;
            }

            textarea {
                outline: #1f3b57;
                height: 3.66rem;
                border: 1px solid #1f3b57;
                border-radius: .05rem;
                padding: .6rem .2rem .6rem;
                font-size: .26rem;
                color: #333;
                line-height: .4rem;
            }

            .textarea-label {
                width: 3rem;
                margin-top: .1rem;

                &:after {
                    content: '';
                }
            }

            & > label {
                position: absolute;
                width: 1.2rem;
                height: .75rem;
                line-height: .75rem;
                font-size: .26rem;
                top: 0;
                left: .18rem;
                text-align: justify;
                text-align-last: justify;
                color: #333;

                &:after {
                    content: ':';
                    display: block;
                    position: absolute;
                    top: 0;
                    right: -.15rem;
                    height: .8rem;
                    line-height: .8rem;
                }

                &.yinsi-text {
                    position: relative;
                    width: 100%;
                    top: 0;
                    left: 0;
                    font-size: .21rem;
                    line-height: .36rem;
                    color: #000000;
                    text-align: left;
                    text-align-last: unset;

                    .text-check {
                        position: relative;
                        top: .02rem;
                        display: inline-block;
                        width: .22rem;
                        height: .22rem;
                        border: 1px solid #333;
                        margin-right: 0.5vw;
                    }

                    .text-blue {
                        color: rgb(17, 30, 84)
                    }
                }
            }

            .checkbox {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 3;
                bottom: 0;
                right: 0;
                opacity: 0;

                &:checked + .yinsi-text .text-check {
                    background: url('~@/assets/apply/check.png') top center/cover no-repeat;
                    background-size: 100%;
                    border: none;
                }
            }
        }

        .yinsi-div {
            height: 1.8rem;
        }
    }

    .company-list {
        box-sizing: border-box;
        width: 100%;
        max-height: 4.3rem;
        overflow-y: auto;
        border-left: 1px solid #e9eef4;
        border-right: 1px solid #e9eef4;
        border-bottom: 1px solid #e9eef4;
        background-color: #fff;
        padding-left: 0;
        padding-top: .1rem;
        padding-bottom: .1rem;
        position: absolute;
        top: .6rem;
        left: 0;
        box-shadow: 0 0 0.1rem 0.03rem #f0eeef;
        -moz-box-shadow: 0 0 .1rem .03rem #f0eeef;
        -webkit-box-shadow: 0 0 0.1rem 0.03rem #f0eeef;
        -ms-box-shadow: 0 0 .1rem .03rem #f0eeef;
        z-index: 6;

        li {
            box-sizing: border-box;
            width: 100%;
            padding-left: .3rem;
            height: .57rem;
            line-height: .57rem;
            text-align: left;
            color: #666;
            transition: all .5s;
            cursor: pointer;
            font-size: .28rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }


    .applyAlert {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgb(0 0 0 / 48%);
        display: flex;
        align-items: center;
        z-index: 10;

        .body2 {
            padding-left: 0.589285rem;
            padding-right: 0.589285rem;
            padding-top: 0.375rem;
            padding-bottom: 0.375rem;
            width: 90%;
            height: 90%;
            background-color: #fff;
            border-radius: 10px;
            margin-left: 5%;
            position: relative;
            font-size: 0.4rem;
            text-align: left;
            padding-top: 2rem;
            box-sizing: border-box;
        }

        .close {
            position: absolute;
            top: 0.5rem;
            width: 0.8rem;
            right: 0.5rem;

        }
    }

    .apply-mask {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgb(0 0 0 / 48%);
        left: 0;
        top: 0;
    }

    .applyConfirm {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 5.32rem;
        /*height: 6.47rem;*/
        display: flex;
        flex-flow: column;
        z-index: 10;
        border-radius: .15rem;
        background-color: #fff;
        text-align: center;
        padding: .8rem .3rem .6rem;

        .content {
            .coupon-infor {
                font-size: .26rem;
                padding-bottom: .1rem;
            }

            .title {
                font-size: .36rem;
                font-weight: bold;
                color: #000000;
                margin-bottom: .45rem;
            }

            .text {
                font-size: .2rem;
                color: #000;
            }


            .coupon-img {
                margin-top: .37rem;
                width: 2.78rem;
                height: 2.78rem;
            }

            .success-img {
                margin-top: .37rem;
                width: 2.78rem;
                height: 2.32rem;
            }

            .btnGroup {
                margin: .45rem -.3rem 0;
                display: flex;
                align-items: center;
                justify-content: center;

                button {
                    @extend .btn;
                    margin: 0 .1rem;
                    font-size: .3rem;
                }

                .btn-line {
                    color: #000;
                    background-image: none;
                    background-color: #fff;
                    border: 1px solid #b20000;
                }
            }

        }

        .close-icon {
            position: absolute;
            z-index: 1;
            right: .2rem;
            top: .2rem;
            .iconfont{
                font-size: .4rem;
            }
        }
    }
</style>
